import { faMinus } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Datepicker from 'components/ui/Datepicker';
import Flex from 'components/ui/Flex';
import { getDateMonthsAgo } from 'utils/dates';
import useAppDispatch from 'hooks/useAppDispatch';
import useAppSelector from 'hooks/useAppSelector';
import { selectOrderSearchFilters, setOrderSearchFilters } from 'store/reducers/orderSlice';
import styled from 'styled-components';

const OrderDateFilter = () => {
    const dispatch = useAppDispatch();
    const { from, to } = useAppSelector(selectOrderSearchFilters);

    const handleChange = (partial: { from?: Date; to?: Date }) => {
        dispatch(setOrderSearchFilters({ from, to, ...partial }));
    };

    return (
        <Wrapper gap="0.25rem" align="center">
            <DatePickerWrapper>
                <Datepicker
                    selectedDate={from ?? getDateMonthsAgo(6)}
                    onChange={(date) => date instanceof Date && handleChange({ from: date })}
                    showIcon
                    filter="None"
                />
            </DatePickerWrapper>
            <FontAwesomeIcon icon={faMinus} size="2xs" />
            <DatePickerWrapper>
                <Datepicker
                    selectedDate={to ?? new Date()}
                    onChange={(date) => date instanceof Date && handleChange({ to: date })}
                    showIcon
                    filter="None"
                />
            </DatePickerWrapper>
        </Wrapper>
    );
};

export default OrderDateFilter;

const Wrapper = styled(Flex)``;

const DatePickerWrapper = styled(Flex)`
    .react-datepicker-wrapper,
    .react-datepicker__input-container {
        width: 100%;
    }

    .selected {
        background-color: ${({ theme }) => theme.colors.main} !important;
        color: #fff !important;
    }

    input {
        width: 100%;
        border: 1px solid ${({ theme }) => theme.colors.border} !important;
        border-radius: var(--radius);
        font-size: 15px !important;
        letter-spacing: 0.02em !important;
        font-weight: 500 !important;
        background-color: ${({ theme }) => theme.colors.fillWhite} !important;
        height: 3rem;
        cursor: pointer;

        &:disabled {
            color: ${({ theme }) => theme.colors.textDisabled} !important;
            cursor: not-allowed !important;
        }
    }

    & * {
        color: ${({ theme }) => theme.colors.text} !important;
    }
`;
